/**
 * Substitui o clicou-botao-whats-principal do botão flutuante do WhatsApp no
 * Brasil. Nome provisório: o marketing ainda vai confirmar.
 */
export const WEBCHAT_OPENED_EVENT = 'abriu-chat-site';
